/* unplugin-vue-components disabled */import script from "./MenuTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuTree.vue?vue&type=script&lang=ts&setup=true"

import "./MenuTree.vue?vue&type=style&index=0&id=03b1e5a7&lang=sass"

const __exports__ = script;

export default __exports__